import * as React from 'react';
import { Message, Icon } from 'semantic-ui-react';

interface BackendStatusProps {
  isOnline: boolean;
}

const BackendStatus: React.FC<BackendStatusProps> = ({ isOnline }) => {
  if (isOnline) {
    return null;
  }

  return (
    <Message warning size="tiny" style={{ margin: '10px', textAlign: 'center' }}>
      <Icon name="warning circle" />
      <Message.Header>Backend Services Offline</Message.Header>
      <p>Some features may be limited. Your data is safe and will sync when connection is restored.</p>
    </Message>
  );
};

export default BackendStatus;
